import React from 'react';
import PreviewRouteLoader from './PreviewRouteLoader';
import PreviewLayoutV2 from '../../components/preview/PreviewLayoutV2';

const ListingPreviewPage: React.FC = () => {
  return (
    <PreviewRouteLoader>
      <PreviewLayoutV2 />
    </PreviewRouteLoader>
  );
};

export default ListingPreviewPage;
